import React, {useEffect, useState} from 'react'
import axios from 'axios'
import {ContactoBanner} from '../../components/Contacto/ContactoBanner'
import {FondosContacto} from '../../components/Contacto/FondosContacto'

function Contacto() {
  const url = 'https://puntosurgdl.com/backend/'

  const [fondosContacto, setFondosContacto] = useState('')

  useEffect(() => {
    getFondosData()
  }, [])

  const getFondosData = () => {
    axios
      .get(url + 'getFondosContacto.php')
      .then((response) => {
        // console.log(response)
        let fondos = response.data.data
        console.log(fondos)
        setFondosContacto(fondos)
      })
      .catch((error) => console.error('Error: ' + error))
  }

  return (
    <div className='row g-5'>
      <ContactoBanner />

      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5'>
          <div className='card-header'>
            <h3 className='card-title'>Imagenes de fondo contacto</h3>
            <h5 className='card-subtitle'>
              Las imágenes deben tener una medida de 1920px por 1000px y no pesar más de 1MB
            </h5>
          </div>
          <div className='card-body'>
            <div className='row'>
              <FondosContacto fondos={fondosContacto} setFondosContacto={setFondosContacto} />
            </div>
          </div>
          {/* <div className='card-footer'>
        <div className='form-check form-switch form-check-custom form-check-solid mt-8'>
          <input className='form-check-input desc-active' type='checkbox' id='desc-active' />
          <label className='form-check-label' for='desc-active'>
            Activar modo imagen
          </label>
        </div>
        <div className='form-group float-end'>
          <button type='submit' className='btn btn-primary mt-6'>
            Guardar
          </button>
        </div>
      </div> */}
        </div>
      </div>
    </div>
  )
}

export {Contacto}
